import classes from "./SubscribeForm.module.css";
import axios from "axios";
import { rootUrl } from "../../../config/setting";
import { useRef } from "react";

const SubscribeForm = () => {
  const emailInputRef = useRef();

  const subscribeSubmitHandler = (event) => {
    event.preventDefault();

    const { email } = event.target.elements;
    let details = {
      "your-email": email.value,
    };

    const form = new FormData();
    for (const field in details) {
      form.append(field, details[field]);
    }

    axios
      .post(
        `${rootUrl}/wp-json/contact-form-7/v1/contact-forms/451/feedback`,
        form,
        { headers: { "content-type": "multipart/form-data" } }
      )
      .then(function (response) {
        console.log(response);
        emailInputRef.current.value = "";
        alert(response.data.message);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <form
      onSubmit={subscribeSubmitHandler}
      className={classes["subscribe-form"]}
    >
      <h5 className={classes["subscribe-form__title"]}>
        Subscribe to get our latest blog posts sent directly to your inbox.
      </h5>
      <p className={classes["subscribe-form__text"]}>Subscribe to our blog!</p>
      <input
        ref={emailInputRef}
        type="email"
        id="email"
        name="your-email"
        className={classes["subscribe-form__input-email"]}
        placeholder="Email Address"
      />
      <button className={classes["subscribe-form__button"]}>Subscribe</button>
    </form>
  );
};

export default SubscribeForm;
